package com.pointlessapps.granite.mica.llvm

internal class LlvmCompilerContext {
    private var registerCounter = 1
    private var blockCounter = 1

    fun nextRegister(): String = "%${registerCounter++}"
    fun nextBlock(prefix: String = "block"): String = "${prefix}_${blockCounter++}"


    // Function Signatures
    data class FunctionSignature(val name: String, val argCount: Int, val hasVararg: Boolean)
    private val functions = mutableMapOf<String, FunctionSignature>()
    
    // Structs
    private val structs = mutableMapOf<String, List<String>>() // struct name -> list of property names

    fun declareFunction(name: String, argCount: Int, hasVararg: Boolean) {
        functions[name] = FunctionSignature(name, argCount, hasVararg)
    }

    fun getFunctionSignature(name: String): FunctionSignature? = functions[name]
    
    fun declareStruct(name: String, properties: List<String>) {
        structs[name] = properties
    }
    
    // Attempt to guess the struct type based on the property requested (hack for dynamic PoC)
    fun getStructPropertyIndex(propertyName: String): Pair<String, Int>? {
        for ((structName, props) in structs) {
            val idx = props.indexOf(propertyName)
            if (idx != -1) return Pair(structName, idx)
        }
        return null
    }

    // Scope management
    data class VariableInfo(val ptr: String, var type: String)
    private val scopeStack = mutableListOf(mutableMapOf<String, VariableInfo>())
    private val loopEndLabels = mutableListOf<String>()

    // Global String constants
    val stringConstants = mutableMapOf<String, String>()
    private var stringCounter = 0

    fun declareStringConstant(value: String): String {
        return stringConstants.getOrPut(value) {
            "@.str.const.${stringCounter++}"
        }
    }

    fun pushScope() {
        scopeStack.add(mutableMapOf())
    }

    fun popScope() {
        scopeStack.removeLast()
    }

    fun declareVariable(name: String, ptr: String, type: String = "i64") {
        scopeStack.last()[name] = VariableInfo(ptr, type)
    }

    fun getVariableInfo(name: String): VariableInfo? {
        for (i in scopeStack.indices.reversed()) {
            if (scopeStack[i].containsKey(name)) {
                return scopeStack[i][name]
            }
        }
        return null
    }
    
    fun getVariablePtr(name: String): String? = getVariableInfo(name)?.ptr

    fun pushLoopEndLabel(label: String) {
        loopEndLabels.add(label)
    }

    fun popLoopEndLabel() {
        loopEndLabels.removeLast()
    }

    fun getCurrentLoopEndLabel(): String? {
        return loopEndLabels.lastOrNull()
    }
}
